(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("PrivacyModalCtrl", ["$translate", privacyModalCtrl]);
    function privacyModalCtrl($translate) {
        var vm = this;
        var lang = $translate.proposedLanguage() || $translate.use();
        vm.privacy = "app/public/" + lang + "/privacy.html";
    }
}());
